/* eslint-disable react/require-default-props */
/* eslint-disable import/no-cycle */
import React from 'react';
import PropTypes from 'prop-types';
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid';
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography';
import makeStyles from 'housecall-ui/dist/DesignSystem/Styles/makeStyles';
import HousecallThemeProvider from 'housecall-ui/dist/DesignSystem/Styles/HousecallThemeProvider';
import Alert from 'housecall-ui/dist/DesignSystem/Feedback/Alert/Alert';
import BookDemoButton from './BookDemoButton';
import WarningBar from './WarningBar';
import ErrorBar from './ErrorBar';
import NoticeBar from './NoticeBar';
import UpgradeButton from './UpgradeButton';
import { isPresent } from 'utils/isPresent';

export const WARNING_BAR = 'warning';
export const ERROR_BAR = 'error';
export const SUCCESS_BAR = 'success';
export const TRIAL_EXPIRING_BAR = 'trial_expiring';
export const TRIAL_EXPIRING_SOON_BAR = 'trial_expiring_soon';
export const TRIAL_EXPIRED_BAR = 'trial_expired';

const useStyles = makeStyles((theme) => ({
  clickableBar: {
    cursor: 'pointer',
  },
  container: {
    boxShadow: '0 2px 2px 0 rgba(0,0,0,0.2)',
  },
  trialExpiringBar: {
    backgroundColor: theme.palette.primary[50],
    color: theme.palette.black.primary,
  },
  trialExpiringSoonBar: {
    backgroundColor: theme.palette.alert.main,
  },
  trialExpiredBar: {
    backgroundColor: theme.palette.error.main,
  },
}));

const BannerBar = ({
  onBarClick,
  type,
  hasHeader,
  message,
  shouldShowUpgrade,
  shouldShowBookDemo,
}) => {
  const {
    clickableBar,
    container,
    trialExpiredBar,
    trialExpiringSoonBar,
    trialExpiringBar,
  } = useStyles();

  let bannerProps = { className: container };

  if (isPresent(onBarClick)) {
    bannerProps = {
      className: `${container} ${clickableBar}`,
      onClick: () => onBarClick(),
    };
  }
  switch (type) {
    case TRIAL_EXPIRING_BAR:
      return (
        <NoticeBar
          hasHeader={hasHeader}
          message={message}
          className={trialExpiringBar}
        >
          <HousecallThemeProvider>
            {shouldShowUpgrade && <UpgradeButton onBarClick={onBarClick} />}
            {shouldShowBookDemo && <BookDemoButton />}
          </HousecallThemeProvider>
        </NoticeBar>
      );
    case TRIAL_EXPIRING_SOON_BAR:
      return (
        <NoticeBar
          hasHeader={hasHeader}
          message={message}
          className={trialExpiringSoonBar}
        >
          <HousecallThemeProvider>
            {shouldShowUpgrade && <UpgradeButton onBarClick={onBarClick} />}
            {shouldShowBookDemo && <BookDemoButton />}
          </HousecallThemeProvider>
        </NoticeBar>
      );
    case TRIAL_EXPIRED_BAR:
      return (
        <NoticeBar
          hasHeader={hasHeader}
          message={message}
          className={trialExpiredBar}
        >
          <HousecallThemeProvider>
            <UpgradeButton onBarClick={onBarClick} />
          </HousecallThemeProvider>
        </NoticeBar>
      );
    case WARNING_BAR:
      return (
        <WarningBar
          hasHeader={hasHeader}
          message={message}
          bannerProps={bannerProps}
        />
      );
    case ERROR_BAR:
      return (
        <ErrorBar
          message={message}
          bannerProps={bannerProps}
        />
      );
    case SUCCESS_BAR:
      return <Alert severity="success">{message}</Alert>;
    default:
      return (
        <HousecallThemeProvider>
          <Grid
            container
            spacing={0}
            alignItems="center"
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...bannerProps}
            style={{ backgroundColor: '#ffffff' }}
          >
            {hasHeader && <Grid item xs={12} style={{ padding: 2, backgroundColor: '#bdbdbd' }} />}
            <Grid item xs={12} style={{ verticalAlign: 'center', paddingLeft: 24 }}>
              <Typography type="body2" style={{ fontSize: 13 }}>
                {message}
              </Typography>
            </Grid>
          </Grid>
        </HousecallThemeProvider>
      );
  }
};

BannerBar.propTypes = {
  type: PropTypes.string,
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  hasHeader: PropTypes.bool,
  onBarClick: PropTypes.func,
  shouldShowUpgrade: PropTypes.bool,
  shouldShowBookDemo: PropTypes.bool,
};

export default BannerBar;
